/**
 * Máquina de estados da SEPARAÇÃO vista pelo quadro: PENDENTE ->
 * EM_SEPARACAO -> SEPARADA, CANCELADA das duas primeiras, e reabrir de volta
 * a PENDENTE. O componente Kanban é compartilhado (_shared/quadro).
 */

/** Transicao de estado necessaria para levar `atual` ate a coluna destino.
 *  Retorna null (nao muda situacao, so etapa), "invalid" (drop proibido) ou a acao. */
export function transicaoParaColuna(atual, situacoesColuna) {
  if (!situacoesColuna || situacoesColuna.length === 0) return null; // coluna operacional
  if (situacoesColuna.includes(atual)) return null; // ja esta nessa situacao
  const alvo = situacoesColuna[0];
  if (alvo === "EM_SEPARACAO" && atual === "PENDENTE") return "iniciar";
  if (alvo === "SEPARADA" && (atual === "PENDENTE" || atual === "EM_SEPARACAO")) return "separar";
  if (alvo === "CANCELADA" && (atual === "PENDENTE" || atual === "EM_SEPARACAO")) return "cancelar";
  if (alvo === "PENDENTE" && (atual === "SEPARADA" || atual === "CANCELADA")) return "reabrir";
  return "invalid";
}
